import { Ionicons } from '@expo/vector-icons';
import React from 'react';
import { TouchableOpacity, StyleSheet, ViewStyle } from 'react-native';

import { Text } from './text';

import { useTheme } from '@/components/theme-provider';
import type { IconName } from '@/types/icons';


export interface ChipProps {
	children: React.ReactNode;
	onPress?: () => void;
	selected?: boolean;
	disabled?: boolean;
	style?: ViewStyle;
	textStyle?: any; // Allow any style for text
	icon?: IconName;
	mode?: 'flat' | 'outlined';
	compact?: boolean;
	testID?: string;
}

export const Chip: React.FC<ChipProps> = ({
	children,
	onPress,
	selected = false,
	disabled = false,
	style,
	textStyle,
	icon,
	mode = 'outlined',
	testID,
}) => {
	const theme = useTheme();

	const chipStyle: ViewStyle = {
		backgroundColor: selected ? theme.colors.primary : theme.colors.surface,
		borderColor: theme.colors.outline,
		borderWidth: 1,
		borderRadius: 16,
		paddingHorizontal: 12,
		paddingVertical: 6,
		alignItems: 'center',
		justifyContent: 'center',
		opacity: disabled ? 0.5 : 1,
	};

	const textColor = selected ? theme.colors.onPrimary : theme.colors.onSurface;

	return (
		<TouchableOpacity
			testID={testID}
			style={[chipStyle, style]}
			onPress={onPress}
			disabled={disabled}
			activeOpacity={0.7}
			accessibilityRole="button"
			accessibilityState={{ selected, disabled }}
		>
			{icon && (
				<Ionicons
					name={icon}
					size={16}
					color={textColor}
					style={styles.icon}
				/>
			)}
			<Text
				variant="labelMedium"
				style={[{ color: textColor }, textStyle]}
			>
				{children}
			</Text>
		</TouchableOpacity>
	);
};

const styles = StyleSheet.create({
	icon: {
		marginRight: 4,
	},
});
